module.exports = __webpack_public_path__ + "static/media/Avatars_Male-08.0a2c2813.png";